export default __webpack_public_path__ + "static/media/55.67748224.png";